export const contact = {
  modal: {
    remove: {
      content: `Вы действительно хотите удалить контакт <b>{contact}<b>?`
    }
  },

  form: {
    title: {
      edit: {
        main: 'Данные контакта'
      }
    }
  },

  table: {
    field: {
      first_name: 'Имя',
      last_name: 'Фамилия',
      full_name: 'ФИО',
      email: 'Email',
      contact_methods: 'Контакт методы',
      contact_method: 'Контакт метод',
      label: 'Иконка'
    }
  }
};
